$(function () {
    $('#js-shift-year').on('change', (e) => {
        $(e.target).closest("form").submit();
    });
    $('#js-shift-month').on('change', (e) => {
        $(e.target).closest("form").submit();
    });
});